export default __webpack_public_path__ + "static/media/mewzik.46b1e320.png";